export default __webpack_public_path__ + "static/media/sidebar-green.680f749a.png";